import { gridSize, gridSizeError, sameGridSize, resizeGridCells, isRegularGridCell } from '../services/mapGridSizing'

export default {
  data () { return { appliedGridSize: null, gridDimensionError: '', gridResizePending: false, gridApplyPromise: null } },
  watch: { leaveOpen (value) { if (!value && this.gridResizePending) this.queueGridResize() } },
  beforeDestroy () { this.cancelGridResize() },
  methods: {
    cancelGridResize () { window.clearTimeout(this.gridResizeTimer); this.gridResizeTimer = null },
    syncGridDimensions () {
      this.cancelGridResize(); this.gridResizePending = false
      const size = gridSize(this.form)
      this.gridDimensionError = gridSizeError(size)
      if (!this.gridDimensionError) this.appliedGridSize = size
    },
    queueGridResize () {
      this.cancelGridResize()
      if (!this.selected || this.readOnly || this.loading || this.saving) return
      this.gridDimensionError = gridSizeError(gridSize(this.form))
      this.gridResizePending = !sameGridSize(gridSize(this.form), this.appliedGridSize)
      if (this.gridDimensionError || !this.gridResizePending) return
      // 避免输入12时先按1列重铺；离开输入框或保存会立即处理，无需寻找折叠区按钮。
      this.gridResizeTimer = window.setTimeout(() => { if (!this.leaveOpen) { if (this.$messageBox.state.current && !this.gridApplyPromise) this.queueGridResize(); else this.applyGridDimensions() } }, 450)
    },
    applyGridDimensions (options = {}) {
      if (this.gridApplyPromise) return this.gridApplyPromise
      const operation = this.applyGridDimensionsOnce(options)
      this.gridApplyPromise = operation
      return operation.finally(() => { if (this.gridApplyPromise === operation) this.gridApplyPromise = null })
    },
    async applyGridDimensionsOnce (options = {}) {
      this.cancelGridResize()
      if (!this.selected || this.readOnly || this.loading || this.saving) return false
      const size = gridSize(this.form)
      this.gridDimensionError = gridSizeError(size)
      if (this.gridDimensionError) return false
      const changed = !sameGridSize(size, this.appliedGridSize)
      if (!changed && !options.forceRebuild) { this.gridResizePending = false; return true }
      if (!this.checkSceneApplied()) return false
      const configured = this.selectedId || this.gridSchemes.length || this.objects.length || this.cells.length !== this.appliedGridSize?.rows * this.appliedGridSize?.cols || this.cells.some(cell => cell.zone !== '居住区' || cell.population !== 50 || cell.economy !== 50 || cell.risk !== 1 || cell.dividable === false || !isRegularGridCell(cell, this.appliedGridSize))
      if (configured || options.forceRebuild) {
        const text = options.resetAttributes
          ? '重新生成会覆盖单元几何和属性，并清空参考网格；地图对象和部件点位保留。确认继续？'
          : '调整行列或尺寸将重新铺设底图单元，保留同一行列的单元属性，移除超出新行列范围的单元，并清空参考网格。地图对象和部件点位保留，关联与坐标需重新校验。确认调整？'
        const target = this.selected
        const accepted = await this.$messageBox.confirm(text)
        if (this._isDestroyed || this.selected !== target || !sameGridSize(size, gridSize(this.form))) return false
        if (!accepted) {
          Object.assign(this.form, this.appliedGridSize)
          this.gridResizePending = false; this.gridDimensionError = ''
          this.ok('已取消调整，恢复原行列、尺寸及底图配置')
          return false
        }
      }
      const oldSize = this.appliedGridSize
      if(this.resizeMapScene)this.resizeMapScene(oldSize,size)
      this.cells = resizeGridCells(this.cells, size, !options.resetAttributes)
      Object.assign(this.form, size, { unitWidth: size.width / size.cols, unitHeight: size.height / size.rows })
      if (!oldSize || oldSize.width !== size.width || oldSize.height !== size.height) Object.assign(this.form, { centerX: size.width / 2, centerY: size.height / 2, minX: 0, minY: 0, maxX: size.width, maxY: size.height })
      this.gridSchemes = []; this.selectedCells = []; this.selectedCell = null; this.cellForm = {}
      this.editedScheme = ''; this.schemeForm = { code: 'A', name: '参考网格A' }
      this.stopMapInteraction(); this.syncGridDimensions()
      const ids = new Set(this.cells.map(cell => cell.id))
      const missing = this.objects.filter(object => object.cellId && !ids.has(object.cellId)).length
      const outside = this.partPoints.filter(point => point.x < 0 || point.y < 0 || point.x > size.width || point.y > size.height).length
      this.ok('底图已更新为 ' + size.rows + ' 行 × ' + size.cols + ' 列，共 ' + this.cells.length + ' 个单元；请检查参考网格后保存' + (missing ? '；有' + missing + '个地图对象需重新关联单元' : '') + (outside ? '；有' + outside + '个部件点位超出新范围，需调整坐标' : ''))
      return true
    },
    async openMapPreview () {
      if (!this.readOnly && !this.checkSceneApplied()) return
      if (!this.readOnly && !await this.applyGridDimensions()) {
        if (this.gridDimensionError) this.fail({ message: this.gridDimensionError })
        return
      }
      this.previewOpen = true
    }
  }
}
